module.exports = __webpack_public_path__ + "1a1637e5857b851a6e10b2e0ae5d81fb.png";